import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../../widgets/layout/CardUI'
import BadgeUI from '../../../../widgets/output/BadgeUI'
import FileUploadModalSF from '../../../../widgets/form/FileUploadModalSF'
import ButtonTinyWithSpinnerUI from '../../../../widgets/action/ButtonTinyWithSpinnerUI'
import { KvRowUI, KvSectionUI } from '../../../../widgets/layout/KvRowUI'
import './TermSheetSign.css'

const TermSheetSignUI = ({ context, loan, onRefreshClick,
  onGenerateTShtml2pdf, generateTShtml2pdfSubmitted, generateTShtml2pdfErrorList,
  onGenLeegTSfromHTML, genLeegTSfromHTMLSubmitted, genLeegTSfromHTMLSuccessMsg, genLeegTSfromHTMLErrorList,
  tsPDFUploadMode, onTSPDFUploadClick, onTSPDFUpload, onTSPDFUploadCancel,
  tsPDFFileId, tsPDFName, tsPDFType, tsPDFSize,
  tsPDFUploadSuccessMsg, tsPDFUploadErrorList, tsPDFUploadSubmitted,
  documentList, onDownloadDocClick,
}) =>
  <div className='ts_sign'>
    <CardUI title={
      <div className='g_flex_h'>
        <span>Approval and acceptance</span>
        <BadgeUI label={loan.termSheet.dateF1 ? loan.termSheet.status : 'not_initiated'} />
      </div>
    }>
      <KvSectionUI label='Status' />
      <StatusRowUI
        label='Offered'
        done={!!loan.termSheet.dateF1}
        value={loan.termSheet.dateF1 || 'Not offered'}
      />
      <StatusRowUI
        label='Lender approved'
        done={!!loan.termSheet.reviewDateF1}
        value={loan.termSheet.reviewDateF1 || 'Not approved'}
      />
      <StatusRowUI
        label='Borrower accepted'
        done={!!loan.termSheet.acceptDateF1}
        value={loan.termSheet.acceptDateF1 || 'Promoter not accepted'}
      />

      {
        !loan.termSheet.acceptDateF1 &&
        <div className='actions'>
          <div className='action_card'>
            <span className='action_title'>Standard term sheet</span>
            <span className='g_muted action_hint'>
              Generate from current terms and publish for e-sign
            </span>
            {
              generateTShtml2pdfErrorList &&
              <span className='g_error'>{generateTShtml2pdfErrorList}</span>
            }
            <Link className='g_link' onClick={onGenerateTShtml2pdf} to='#'>
              Preview PDF that will be published
            </Link>
            <ButtonTinyWithSpinnerUI label='Publish Standard Term Sheet'
              onClick={onGenLeegTSfromHTML} className='g_m_top_50'
              alignLeft={true} busy={genLeegTSfromHTMLSubmitted}
              successMsg={genLeegTSfromHTMLSuccessMsg} errorList={genLeegTSfromHTMLErrorList}
              disabled={!loan.termSheet.interestRate}
            />
          </div>
          <CustomPublishUI
            onTSPDFUploadClick={onTSPDFUploadClick}
            tsPDFUploadSubmitted={tsPDFUploadSubmitted}
            tsPDFUploadSuccessMsg={tsPDFUploadSuccessMsg}
            tsPDFUploadErrorList={tsPDFUploadErrorList}
            tsPDFName={tsPDFName}
            tsPDFType={tsPDFType}
            tsPDFSize={tsPDFSize}
          />
        </div>
      }

      {
        loan.termSheet.acceptDateF1 &&
        <div className='actions actions_single'>
          <CustomPublishUI
            onTSPDFUploadClick={onTSPDFUploadClick}
            tsPDFUploadSubmitted={tsPDFUploadSubmitted}
            tsPDFUploadSuccessMsg={tsPDFUploadSuccessMsg}
            tsPDFUploadErrorList={tsPDFUploadErrorList}
            tsPDFName={tsPDFName}
            tsPDFType={tsPDFType}
            tsPDFSize={tsPDFSize}
          />
        </div>
      }

      <DownloadUI loan={loan}
        documentList={documentList} onDownloadDocClick={onDownloadDocClick}
        documentCode='term_sheet'
      />

      <FileUploadModalSF
        context={context}
        uploadMode={tsPDFUploadMode}
        onCancelClick={onTSPDFUploadCancel}
        signedUrlApi={`/api/su/loans/${loan.loanId}/termSheet/pdf/fileUploadSignedUrl`}
        onUpload={onTSPDFUpload}
      />
    </CardUI>
  </div>

const StatusRowUI = ({ label, done, value }) =>
  <div className={`status_row ${done ? 'done' : 'pending'}`}>
    <span className='status_mark'>{done ? '✓' : '·'}</span>
    <KvRowUI label={label} value={value} className='status_kv' />
  </div>

const CustomPublishUI = ({
  onTSPDFUploadClick, tsPDFUploadSubmitted, tsPDFUploadSuccessMsg, tsPDFUploadErrorList,
  tsPDFName, tsPDFType, tsPDFSize,
}) =>
  <div className='action_card'>
    <span className='action_title'>Custom term sheet</span>
    <span className='g_muted action_hint'>
      Upload your own PDF and publish for e-sign
    </span>
    <ButtonTinyWithSpinnerUI label='Publish with PDF Upload'
      onClick={onTSPDFUploadClick} className='g_m_top_50'
      alignLeft={true} busy={tsPDFUploadSubmitted}
      successMsg={tsPDFUploadSuccessMsg} errorList={tsPDFUploadErrorList}
    />
    {
      tsPDFName &&
      <div className='g_muted upload_meta'>
        {tsPDFName} · {tsPDFType} · {tsPDFSize} bytes
      </div>
    }
  </div>

const DownloadUI = ({ loan, documentList, onDownloadDocClick, documentCode }) => {
  const docs = documentList
    ? documentList.filter(d => d.documentId === documentCode)
    : []

  if (docs.length === 0) return null

  return (
    <div className='published'>
      {
        docs.map(({ documentId }) =>
          <Link key={documentId} className='g_link' onClick={onDownloadDocClick} to='#' data-type={documentCode}>
            Download published Term Sheet
          </Link>
        )
      }
      {
        (loan.termSheet.templateName || loan.termSheet.version) &&
        <span className='g_muted meta'>
          {[
            loan.termSheet.templateName && `Template: ${loan.termSheet.templateName}`,
            loan.termSheet.version,
          ].filter(Boolean).join(' · ')}
        </span>
      }
    </div>
  )
}

export default TermSheetSignUI
